let url = window.location.href;
const querystring = window.location.search
let searchParams = new URLSearchParams(querystring);
if(searchParams.has('callMe')){
    document.querySelector('#modalCallNow > a').click();
}

setTimeout(function() {
    window.location = "https://www.somvera.cat/"
}, 5000);

// SITE.home.index = function(){
//
//     console.log('index');
//
//
// }
